import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Drop = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="61" viewBox="0 0 61 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.247 8.07692C14.5436 20.4636 0.13443 38.8575 0.13443 59.2541C0.13443 59.2541 0.13443 59.2541 0.13443 59.2541C0.13443 75.9594 13.6777 89.5018 30.383 89.5018C47.0884 89.5018 60.6307 75.9594 60.6307 59.2541C60.6307 59.0496 60.6287 58.8455 60.6247 58.642C60.3197 40.4186 46.4905 22.6843 36.7345 10.1734C33.9387 6.58817 31.4775 3.4319 29.7648 0.816C28.2891 2.91707 26.382 5.35159 24.247 8.07692Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
